import { render, staticRenderFns } from "./HelpForm.vue?vue&type=template&id=0cc22b9c&"
import script from "./HelpForm.vue?vue&type=script&lang=js&"
export * from "./HelpForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports